import { makeStyles } from '@mui/styles';
import { Button, Checkbox, Grid, Typography } from 'apollo-react';
import Modal from 'apollo-react/components/Modal';
import React, { useState } from 'react';

import { useTranslation } from '../../../custom-hooks/useTranslation';
import { EXPORT_GUIDE } from '../../constants/export.constants';

const useStyles = makeStyles({
  modal: {
    minWidth: '70%',
  },
});

const getCurrentChangedItems = ({ itemsList = [], selectedChangedItems = [] }) => {
  return itemsList.map((item) => ({
    ...item,
    checked: selectedChangedItems.includes(item.Value),
  }));
};

const highLoadedItems = [
  {
    Name: 'Clients',
    Value: 'chkAppMigrationClients',
  },
  {
    Name: 'Entities Master Setup',
    Value: 'chkAppMigrationMasterSetupData',
  },
];

const getSelectedItemsValues = (items = []) =>
  items.filter((item) => item.checked).map((item) => item.Value);

const ChangedItemsModal = ({
  onClose,
  changedItemsList = [],
  selectedChangedItems = [],
  updateExportData,
}) => {
  const classes = useStyles();
  const translateString = useTranslation();
  const [checkAll, setCheckAll] = useState(true);
  const [currentHighLoadedItems, setCurrentHighLoadedItems] = useState(
    getCurrentChangedItems({
      itemsList: highLoadedItems,
      selectedChangedItems,
    })
  );
  const [currentChangedItems, setCurrentChangedItems] = useState(
    getCurrentChangedItems({
      itemsList: changedItemsList,
      selectedChangedItems,
    })
  );

  const modifyChangedItems = ({ items, checked }) => {
    return items.map((item) => ({ ...item, checked }));
  };

  const handleSave = () => {
    const selectedItemsValues = getSelectedItemsValues([
      ...currentChangedItems,
      ...currentHighLoadedItems,
    ]);

    updateExportData('selectedChangedItems', selectedItemsValues);

    onClose();
  };

  const buttonList = [
    {
      label: translateString('Cancel'),
      'ui-ta': 'ExportAppMigrationModal-CancelButton',
    },
    {
      label: translateString('Save'),
      onClick: handleSave,
      'ui-ta': 'ExportAppMigrationModal-ImportButton',
    },
  ];

  const handleToogleCheckAll = () => {
    setCheckAll((prev) => !prev);

    const modifiedChangedItems = modifyChangedItems({
      items: getCurrentChangedItems({ itemsList: currentChangedItems, selectedChangedItems }),
      checked: !checkAll,
    });

    setCurrentChangedItems(modifiedChangedItems);
  };

  const handleHighLoadedItemCheck = (event) => {
    const { name, checked } = event.target;

    setCurrentHighLoadedItems((prevState) => {
      const updatedItems = prevState.map((item) => {
        if (item.Value === name) {
          item.checked = checked;
        }
        return item;
      });
      return updatedItems;
    });
  };

  const handleCheck = (event) => {
    const { name, checked } = event.target;

    setCurrentChangedItems((prevState) => {
      const updatedItems = prevState.map((item) => {
        if (item.Value === name) {
          item.checked = checked;
        }
        return item;
      });
      return updatedItems;
    });
  };

  return (
    <Modal
      open
      variant="default"
      onClose={onClose}
      title={translateString('All Changed Items')}
      buttonProps={buttonList}
      className={classes.modal}
      disableBackdropClick
      disableEscapeKeyDown
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography
            dangerouslySetInnerHTML={{
              __html: EXPORT_GUIDE.changedItemsModal.excludedItemsDescription,
            }}
          ></Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            {currentHighLoadedItems.map((changedItem) => (
              <Grid item xs={3} key={changedItem} sx={{ paddingTop: '0 !important' }}>
                <Checkbox
                  key={changedItem.Value}
                  value={changedItem.Value}
                  label={changedItem.Name}
                  checked={changedItem.checked}
                  name={changedItem.Value}
                  onChange={handleHighLoadedItemCheck}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Typography
            dangerouslySetInnerHTML={{
              __html: EXPORT_GUIDE.changedItemsModal.includedItemsDescription,
            }}
          ></Typography>
        </Grid>
        <Grid item xs={12}>
          <Button onClick={handleToogleCheckAll}>
            {translateString(checkAll ? 'Uncheck All' : 'Check All')}
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            {currentChangedItems.map((changedItem) => (
              <Grid item xs={3} key={changedItem} sx={{ paddingTop: '0 !important' }}>
                <Checkbox
                  key={changedItem.Value}
                  value={changedItem.Value}
                  label={changedItem.Name}
                  checked={changedItem.checked}
                  name={changedItem.Value}
                  onChange={handleCheck}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default ChangedItemsModal;
